import * as React from "react";
import SimpleDictionaryFormConfig from "../../../components/common/SimpleDictionaryFormConfig";
import { useTranslation } from 'react-i18next';

const fields = {

        config: { columns: 2 },
        fields: [
            {
                name: "productName",
                label: "verificationTool.productName",
                column: 1,
                mandatory: true,
                type: "dictionary",
                dictionary: "productName",
                creationForm: SimpleDictionaryFormConfig

            },
            {
                name: "internalNumber",
                label: "verificationTool.internalNumber",
                column: 1,
            },
            {
                name: "supplier",
                label: "verificationTool.supplier",
                column: 1,
                type: "dictionary",
                dictionary: "supplier",
                creationForm: SimpleDictionaryFormConfig
            },
            {
                name: "toolStandard",
                label: "verificationTool.toolStandard",
                column: 1,
                type: "dictionary",
                dictionary: "toolStandard",
                creationForm: SimpleDictionaryFormConfig
            },
            {
                name: "multipleTool",
                label: "verificationTool.multipleTools",
                column: 1,
                type: "boolean",
                mandatory: true
            },
            {
                name: "tipsCount",
                label: "verificationTool.numberOfTips",
                column: 1,
                type: "number",
                mandatory: true,
                conditionalOn: "multipleTool"
            },
            {
                name: "toolsCount",
                label: "verificationTool.numberOfTools",
                column: 1,
                type: "number",
                mandatory: true
            },

            {
                name: "toolLabelling",
                label: "verificationTool.toolLabelling",
                column: 1,
            },
            {
                name: "toolTypesCreation",
                label: "verificationTool.toolTypesCreation",
                column: 1,
                type: "checkGroup",
                enumType: "toolTypesCreation",
                options: ["UPPER", "LOWER", "MATRIX_SEGMENT"],
                mandatory: true,
                validate: (value) => {
                    return value && value.length > 0;
                }
            },
            {
                name: "steelType",
                label: "verificationTool.steelType",
                column: 2,
                type: "dictionary",
                dictionary: "steelType",
                groupedDictionary: true,
                creationForm: SimpleDictionaryFormConfig
            },
            {
                name: "withCover",
                label: "verificationTool.withCover",
                column: 2,
                type: "boolean",
            },
            {
                name: "cover",
                label: "verificationTool.cover",
                column: 2,
                type: "dictionary",
                dictionary: "cover",
                creationForm: SimpleDictionaryFormConfig,
                conditionalOn: "withCover"
            },
            {
                name: "withUpperWedge",
                label: "verificationTool.withUpperWedge",
                column: 2,
                type: "boolean",
            },
            {
                name: "withLowerWedge",
                label: "verificationTool.withLowerWedge",
                column: 2,
                type: "boolean",
            },
            {
                name: "matrixOrSegment",
                label: "verificationTool.matrixOrSegment",
                column: 2,
                mandatory: true,
                type: "enum",
                enumType: "enums/matrixOrSegment",
            },
            {
                name: "segmentsCount",
                label: "verificationTool.segmentsCount",
                column: 2,
                type: "number",
                mandatory: true,
                conditionalOn: "matrixOrSegment",
                conditionalOnMatchValue: "SEGMENT"
            },
            {
                name: "segmentSteelType",
                label: "verificationTool.segmentSteelType",
                column: 2,
                conditionalOn: "matrixOrSegment",
                conditionalOnMatchValue: "SEGMENT"
            },
            {
                name: "matrixSteelType",
                label: "verificationTool.matrixSteelType",
                column: 2,
                type: "dictionary",
                dictionary: "matrixSteelType",
                creationForm: SimpleDictionaryFormConfig,
                conditionalOn: "matrixOrSegment",
                conditionalOnMatchValue: "MATRIX"
            },
            {
                name: "matrixWithInput",
                label: "verificationTool.matrixWithInput",
                column: 2,
                type: "boolean",
                conditionalOn: "matrixOrSegment",
                conditionalOnMatchValue: "MATRIX"
            },
            {
                name: "matrixInputType",
                label: "verificationTool.matrixInputType",
                column: 2,
                type: "enum",
                enumType: "enums/matrixInputType",
                conditionalOn: "matrixWithInput"
            },
            {
                name: "producedPillsCount",
                label: "verificationTool.producedPillsCount",
                column: 2,
                type: "number",
            },
            {
                name: "additionalDocuments",
                label: "verificationTool.additionalDocuments",
                type: "file",
                column: 2,
            },
            {
                name: "additionalInformation",
                label: "verificationTool.additionalInformation",
                type: "textarea",
                column: 2,
            },
            {
                name: "template",
                label: "verificationTool.template",
                column: 2,
                mandatory: true,
                hideForReadOnly: true,
                type: "boolean"
            },
            {
                name: "templateName",
                label: "verificationTool.templateName",
                column: 2,
                mandatory: true,
                hideForReadOnly: true,
                conditionalOn: "template"

            },


        ]


    };

export default fields;